export default {"src":"/_next/static/media/play_regular.cbb80c5d.svg","height":24,"width":24};